import React from 'react';
import { ConfirmationDialog } from 'components/Dialogs';
import { APPROVE_FOR_CLIENT_ACCESS_LABEL, MARK_AS_DRAFT_LABEL } from 'dashboard409a/common/constants/messages/valuationMethodsDetailTable';
import { ApproveForClientsDialogWrapperProps } from './ApproveForClientsDialogWrapper.props';


const ApproveForClientsDialogWrapper = ({ isApprovedForClients, ...props }: ApproveForClientsDialogWrapperProps) => (
  <ConfirmationDialog
    {...props}
    title={isApprovedForClients ? MARK_AS_DRAFT_LABEL : APPROVE_FOR_CLIENT_ACCESS_LABEL}
  />
);

export default ApproveForClientsDialogWrapper; 